import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { hexColorSchema } from '@zaoblako/shared/modules/serde/schemas/hex-color.schema';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';

import * as yup from 'yup';

/** Unit create/update request body */
export interface UnitFormInterface {
  /** Unit full name */
  name: string;
  /** Unit color */
  color?: string;
  /** Unit short name */
  short?: string;
  /** Special code of this unit for Atrium CRM (using by some reports) */
  atriumCode?: string;
  /** Is this unit using to distribute costs (`true` value must be a single for tenant) */
  distributeCosts?: boolean;
}

/** Unit create/update request body DTO scheme */
export const UnitFormDto = SerdeDtoClass.create<UnitFormInterface>(CatalogDtosKeysEnum.UNIT_FORM_DTO, {
  name: {
    label: 'Название',
    serializer: yup
      .string()
      .min(1, DtoMessageEnum.EMPTY_STRING),
  },
  color: {
    optional: true,
    label: 'Цвет',
    serializer: hexColorSchema,
  },
  short: {
    optional: true,
    label: 'Сокращенное название',
    serializer: yup.string(),
  },
  atriumCode: {
    label: 'Код для "Атриума"',
    optional: true,
    serializer: yup.string(),
  },
  distributeCosts: {
    optional: true,
    label: 'Распределить затраты',
    serializer: yup.boolean(),
  },
});
